import ScheduleWishesForm from '@/components/ScheduleWishesForm/ScheduleWishesForm.vue';

export default {
    components: {
        ScheduleWishesForm,
    },
};
